// LB Hero — Fade + flechas + dots + control de video (sin doble fade)
(function () {
  function wire(root){
    if (!root || root.dataset.lbWired === "1") return;
    root.dataset.lbWired = "1";

    const slides = Array.from(root.querySelectorAll(".lb-hero__slide"));
    const dots   = Array.from(root.querySelectorAll(".lb-dotVis"));
    if (!slides.length) return;

    let index = 0;
    const count      = slides.length;
    const autoplay   = root.dataset.autoplay === "true";
    const interval   = parseInt(root.dataset.interval || "6000", 10);
    const TRANSITION = 450; // ms — debe coincidir con el CSS (opacity .45s)
    let timerId = null;     // usamos setTimeout (no setInterval)
    let isTransitioning = false;
    let navSeq = 0;         // token de navegación para invalidar callbacks viejos

    // utilidades
    const mod = (n) => ((n % count) + count) % count;
    const stopTimer  = () => { if (timerId) { clearTimeout(timerId); timerId = null; } };
    const startTimer = () => {
      stopTimer();
      if (!autoplay) return;
      // si el slide activo es video, el video gobierna el avance (no timer)
      if (slides[index].querySelector("video")) return;
      timerId = setTimeout(() => next("timer"), interval);
    };
    const updateDots = (i) => dots.forEach((d,k)=> d.classList.toggle("is-active", k === i));

    function clearAllVideoHandlers(){
      slides.forEach(s => {
        const v = s.querySelector("video");
        if (v) v.onended = null;
      });
    }

    function playVideoOnce(v, seq){
      if (!v) return;
      try { v.loop = false; v.currentTime = 0; } catch(_){}
      // onended controla el avance; se invalida si cambia el seq
      v.onended = () => {
        if (seq !== navSeq) return;          // hubo otra transición
        if (isTransitioning) return;         // ya estamos cruzando
        next("ended");
      };
      const p = v.play && v.play();
      if (p && p.catch) p.catch(()=>{});
    }

    function crossfade(to, cause){
      if (isTransitioning) return;
      const target = mod(to);
      if (target === index) return;

      isTransitioning = true;
      stopTimer();
      navSeq += 1;                    // nueva navegación
      const seq = navSeq;

      const fromIdx = index;
      const leaving  = slides[fromIdx];
      const entering = slides[target];

      // capas y estado visual
      entering.classList.add("is-entering", "is-active");
      leaving && leaving.classList.add("is-leaving");
      updateDots(target);

      // Arranca el video ENTRANTE ya, sin parar el saliente (para que no “se congele”)
      clearAllVideoHandlers();        // limpia onended rezagados
      const vIn = entering.querySelector("video");
      if (vIn) {
        playVideoOnce(vIn, seq);
      }

      // Completa el crossfade y SOLO entonces resetea el saliente
      setTimeout(() => {
        // si otra transición comenzó, abandona (evita doble fade)
        if (seq !== navSeq) return;

        if (leaving){
          leaving.classList.remove("is-active", "is-leaving");
          const vOut = leaving.querySelector("video");
          if (vOut){ try { vOut.pause(); vOut.currentTime = 0; } catch(_){} vOut.onended = null; }
        }
        entering.classList.remove("is-entering");
        index = target;
        isTransitioning = false;

        // Programa el siguiente avance según el slide activo
        const v = slides[index].querySelector("video");
        if (v) {
          // si es video, el avance lo hará su onended (ya seteado arriba)
        } else {
          startTimer();
        }
      }, TRANSITION);
    }

    function next(cause){ crossfade(index + 1, cause); }
    function prev(cause){ crossfade(index - 1, cause); }

    // Flechas
    const prevBtn = root.querySelector(".lb-hero_arrow-prev");
    const nextBtn = root.querySelector(".lb-hero_arrow-next");
    if (prevBtn) prevBtn.addEventListener("click", () => prev("arrow"));
    if (nextBtn) nextBtn.addEventListener("click", () => next("arrow"));

    // Hover: pausa solo si el activo no es video
    root.addEventListener("mouseenter", stopTimer);
    root.addEventListener("mouseleave", () => {
      if (!slides[index].querySelector("video")) startTimer();
    });

    // Estado inicial: activa el primero y programa avance
    slides.forEach((s,k)=> s.classList.toggle("is-active", k === 0));
    updateDots(0);
    clearAllVideoHandlers();
    const v0 = slides[0].querySelector("video");
    if (v0) {
      // primer slide es video: reproduce y deja que su ended haga next
      playVideoOnce(v0, navSeq);
    } else {
      startTimer();
    }
  }

  function boot(){ document.querySelectorAll(".lb-hero").forEach(wire); }
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);
})();